import { computed, inject, Injectable, signal } from '@angular/core';
import { SubSectionStructureObject } from '../../api/interfaces';
import { CompilingFormService } from './compiling-form.service';
import { FormRulesService } from '../rules/form-rules.service';

@Injectable()
export class CompilingSubSectionService {
  private readonly forms = inject(CompilingFormService);
  private readonly rules = inject(FormRulesService);
  private readonly _uniqueId = signal<string | undefined>(undefined);

  get uniqueId(): string | undefined {
    return this._uniqueId();
  }

  set uniqueId(uniqueId: string) {
    this._uniqueId.set(uniqueId);
  }

  subsection = computed(() => {
    const id = this._uniqueId();
    if (!id) return undefined;

    const module = this.forms.moduleStructure();
    if (!module) return undefined;

    return module[id] as SubSectionStructureObject;
  });

  subsectionVisible = this.rules.isVisible(this._uniqueId);
}
